import { createReducer } from 'helpers/ReducerUtil'
import {
  UPDATE_VALUE
} from './constants'
import {
  TRUE,
  FALSE,
} from 'components/custom/FeatureButton/constants'
import * as R from 'ramda'
const isSameAs = (value) => R.complement(R.propEq('value', value))
/*
 * whenever you change value add to values
 */
const updateValue = (values, action) => {
  let newValues = [...values]
  let feature = {
    ...action.featureObj,
    label: action.value
  }
  // check if exists already and modify that one
  let exists = newValues.find((val) => action.featureObj.value === val.value)
  if (exists) {
    newValues = newValues.map((val) => {
      if (val.value === action.featureObj.value) {
        return feature
      } else {
        return val
      }
    })
  } else {
    newValues = [...newValues, feature]
  }
  return newValues
}

const inputReducer = createReducer([], {
  [UPDATE_VALUE]: updateValue
})

export default inputReducer
